var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 61,
    viewBox: "0 0 58 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 57.6111,
    height: 61,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9375 31.7709C17.3022 31.1353 16.9453 30.2735 16.9453 29.3749C16.9453 28.4763 17.3022 27.6145 17.9375 26.979L37.1085 7.80803C37.4211 7.48435 37.795 7.22618 38.2085 7.04857C38.622 6.87096 39.0666 6.77748 39.5166 6.77357C39.9666 6.76966 40.4128 6.8554 40.8293 7.0258C41.2458 7.19619 41.6242 7.44783 41.9424 7.76602C42.2606 8.08421 42.5122 8.46259 42.6826 8.87907C42.853 9.29555 42.9387 9.7418 42.9348 10.1918C42.9309 10.6417 42.8374 11.0864 42.6598 11.4999C42.4822 11.9134 42.224 12.2873 41.9004 12.5999L25.1254 29.3749L41.9004 46.1499C42.5177 46.7891 42.8593 47.6451 42.8515 48.5337C42.8438 49.4222 42.4874 50.2722 41.8591 50.9005C41.2308 51.5288 40.3808 51.8853 39.4922 51.893C38.6037 51.9007 37.7476 51.5591 37.1085 50.9418L17.9375 31.7709Z",
    fill: "#71B3DE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left_arrow.c6f460ed7d64409496454400a6153ca2.svg";
export { ForwardRef as ReactComponent };